import { Vessel } from '@app-types/index';

/**
 * Simple state store for the currently selected vessel
 * Can be replaced with React Context or Redux if needed
 */
class VesselStoreService {
  private vessel: Vessel | null = null;

  /**
   * Set the current vessel
   */
  setVessel(vessel: Vessel | null): void {
    this.vessel = vessel;
  }

  /**
   * Get the current vessel
   */
  getVessel(): Vessel | null {
    return this.vessel;
  }

  /**
   * Clear the current vessel
   */
  clear(): void {
    this.vessel = null;
  }
}

// Export singleton instance
export const vesselStoreService = new VesselStoreService();
export default VesselStoreService;
